import { loadGoogleMapsScript } from '../../utils/googleMaps'

export default {
  namespaced: true,
  state: {
    formElement: undefined,
    listElement: undefined,
    pageLoad: false,
    googleMapsExists: false,
  },
  mutations: {
    SET_FORM_ELEMENT(state, ref) {
      state.formElement = ref
    },
    SET_LIST_ELEMENT(state, el) {
      state.listElement = el
    },
    SET_PAGELOAD(state, bool) {
      state.pageLoad = bool
    },
    SET_GOOGLE_MAPS(state, bool) {
      state.googleMapsExists = bool
    },
  },
  actions: {
    SET_PAGELOAD_TRUE(context) {
      context.commit('SET_PAGELOAD', true)
    },
    SET_PAGELOAD_FALSE(context) {
      context.commit('SET_PAGELOAD', false)
    },
    LOAD_GOOGLE_MAPS_SCRIPT({ commit }, callback) {
      loadGoogleMapsScript(callback)
      commit('SET_GOOGLE_MAPS', true)
    },
  },

}
